/**
 * 文件路径: D:\XXY\MeiShan_Project\frontend\packages\operator-admin\src\main.ts
 * 应用主入口文件
 */

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import App from './App.vue'
import router from './router'
import { TokenManager } from '@shared'
import { installPermissionDirectives } from '@shared/directives/permission'
import { installElementPlusPopoverCloseFix, installProactiveTokenRefresh } from '@shared/utils'
import { installPassiveEventFix } from './utils/passive-event-fix'

// 样式导入
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import '@shared/styles/theme.css'
import '@shared/styles/form-standards.css'
import '@shared/styles/confirm-dialogs.css'
import './styles/app-theme.css'

// 创建应用实例
// 设置默认暗色主题
document.documentElement.setAttribute('data-theme', 'dark')
document.documentElement.classList.add('dark')

// ✅ 统一修复：Element Plus 下拉/弹层点击空白无法收起问题
installElementPlusPopoverCloseFix()
// ✅ 统一修复：Element Plus 触发的 non-passive listener Violation 刷屏（不影响功能，仅改善控制台噪音）
installPassiveEventFix()

const app = createApp(App)

// 为本应用设置本地存储前缀，确保与其他后台并存登录互不干扰
TokenManager.setKeyPrefix('operator_')

// 配置 Pinia 状态管理
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

// 🔍 调试支持：挂载 Pinia 到 window（仅开发环境）
if (import.meta.env.DEV) {
  ;(window as unknown as Record<string, unknown>).$pinia = pinia
  console.log('✅ [main.ts] Pinia 已挂载到 window.$pinia')
}

// 注册 Element Plus 图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 注册插件
app.use(pinia)
app.use(ElementPlus)
app.use(router)
installPermissionDirectives(app)

// 主动 Token 续期：用户空闲后切回页面时静默刷新，避免首次加载卡顿
installProactiveTokenRefresh('/api/v1/')

// 挂载应用
app.mount('#app')
